import { Outlet } from 'react-router-dom';

const AuthenticatedLayout = () => <Outlet />;

export default AuthenticatedLayout;
